import { FC } from 'react';
import './cssLoader.css';
import loader from '../assets/Loader.svg';

const CssLoadingSpinner: FC<{ isRelative?: boolean }> = ({ isRelative }) => {
	return <img src={loader} alt="rotation-spinner" className={isRelative ? 'loaderRelative' : 'loaderAbsolute'} />;
};

export const CssLoadingSpinnerResize: FC<{ height: string }> = ({ height }) => {
	return (
		<img
			src={loader}
			alt="rotation-spinner"
			style={{ height, animation: 'spin 1s linear infinite', margin: 'auto' }}
		/>
	);
};

export default CssLoadingSpinner;
